import React from "react";

const SalesStatus = () => {
  return <div>SalesStatus</div>;
};

export default SalesStatus;
